import { render, staticRenderFns } from "./MinhaConta.vue?vue&type=template&id=36b27d46&"
import script from "./MinhaConta.vue?vue&type=script&lang=js&"
export * from "./MinhaConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports